import React, { useState } from 'react'
import PropTypes from 'prop-types'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import {
  Box,
  Button,
  ButtonGroup,
  Checkbox,
  FormControlLabel,
  Menu,
  MenuItem,
  Stack,
} from '@mui/material'
import { CommonButton } from '@/components/common'

export const DonorsSelectionToolbar = ({
  selectedCount = 0,
  selectionActionsDisabled = true,
  allSelected = false,
  onToggleSelectAll,
  onSendToSelected,
  onSendToAllDonors,
  onSendToAllEligibleDonors,
  onClearSelection,
  allDonorsCount = null,
  allEligibleDonorsCount = null,
  loadingSendOptions = false,
  showEligibleOption = false,
}) => {
  const [menuAnchor, setMenuAnchor] = useState(null)
  const menuOpen = Boolean(menuAnchor)

  const formatCount = count =>
    loadingSendOptions || count == null ? '...' : `(${count})`

  const handleMenuClose = () => setMenuAnchor(null)

  const handleOptionClick = handler => {
    handleMenuClose()
    handler?.()
  }

  return (
    <Stack
      direction={{ xs: 'column', lg: 'row' }}
      spacing={1}
      alignItems={{ xs: 'stretch', lg: 'center' }}
      sx={{ flex: 1, minWidth: 0 }}
    >
      <FormControlLabel
        control={
          <Checkbox
            checked={allSelected}
            onChange={onToggleSelectAll}
            size='small'
          />
        }
        label={`${selectedCount} donors selected`}
      />
      <Box
        sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', alignItems: 'center' }}
      >
        <ButtonGroup
          variant='contained'
          disableElevation
          sx={{
            boxShadow: '0px 2px 8px 0px #0000001A',
            '& .MuiButton-root': {
              textTransform: 'none',
            },
          }}
        >
          <Button onClick={onSendToSelected}>Send Email</Button>
          <Button
            onClick={event => setMenuAnchor(event.currentTarget)}
            aria-label='More send email options'
            aria-haspopup='menu'
            aria-expanded={menuOpen ? 'true' : undefined}
            sx={{
              minWidth: 40,
              px: 1,
            }}
          >
            <ArrowDropDownIcon />
          </Button>
        </ButtonGroup>
        <Menu anchorEl={menuAnchor} open={menuOpen} onClose={handleMenuClose}>
          {showEligibleOption ? (
            <MenuItem
              onClick={() => handleOptionClick(onSendToAllEligibleDonors)}
            >
              Send to All Eligible Donors {formatCount(allEligibleDonorsCount)}
            </MenuItem>
          ) : null}
          <MenuItem onClick={() => handleOptionClick(onSendToAllDonors)}>
            Send to All Donors {formatCount(allDonorsCount)}
          </MenuItem>
        </Menu>
        <CommonButton
          variant='secondary'
          onClick={onClearSelection}
          disabled={selectionActionsDisabled}
        >
          Clear selection
        </CommonButton>
      </Box>
    </Stack>
  )
}

DonorsSelectionToolbar.propTypes = {
  selectedCount: PropTypes.number,
  selectionActionsDisabled: PropTypes.bool,
  allSelected: PropTypes.bool,
  onToggleSelectAll: PropTypes.func,
  onSendToSelected: PropTypes.func,
  onSendToAllDonors: PropTypes.func,
  onSendToAllEligibleDonors: PropTypes.func,
  onClearSelection: PropTypes.func,
  allDonorsCount: PropTypes.number,
  allEligibleDonorsCount: PropTypes.number,
  loadingSendOptions: PropTypes.bool,
  showEligibleOption: PropTypes.bool,
}
